import { Link } from 'react-router-dom';
import '../index.css';

const Migration = () => {
  const whatsappLink = "https://wa.me/5511964768245?text=Ola%20quero%20migrar%20meu%20projeto%20do%20Lovable%20Cloud%20para%20supabase";

  return (
    <div style={{ background: '#FAFAFA', minHeight: '100vh' }}>
      {/* Hero Section */}
      <section style={{ 
        background: '#FFFFFF',
        padding: 'clamp(48px, 10vw, 80px) 20px',
        textAlign: 'center'
      }}>
        <div style={{ maxWidth: 1200, margin: '0 auto' }}>
          <img 
            src="https://static.lumi.new/02/02fc1d604646fdb67b08d70bb2f6384e.webp" 
            alt="Migração Lovable Cloud para Supabase"
            style={{
              width: '100%',
              maxWidth: 500,
              margin: '0 auto 48px',
              borderRadius: 16
            }}
          />
          
          <h1 style={{
            fontSize: 'clamp(32px, 5vw, 56px)',
            fontWeight: 800,
            color: '#1C1C1C',
            lineHeight: 1.2,
            marginBottom: 24,
            fontFamily: 'Inter, system-ui, sans-serif'
          }}>
            Liberte seu Projeto do Lovable Cloud e Assuma o Controle Total no <span style={{ color: '#3ECF8E' }}>SUPABASE</span>
          </h1>

          <p style={{
            fontSize: 'clamp(18px, 3vw, 24px)',
            color: '#4A4A4A',
            lineHeight: 1.6,
            maxWidth: 800,
            margin: '0 auto 48px',
            fontFamily: 'Inter, system-ui, sans-serif'
          }}>
            Serviço especializado de migração de ponta a ponta. Mantenha o design e a facilidade do Lovable, mas seja o verdadeiro dono do seu banco de dados, sem amarras.
          </p>

          <div style={{ display: 'inline-block', position: 'relative' }}>
            <span style={{
              display: 'block',
              fontSize: 12,
              color: '#3ECF8E',
              fontWeight: 600,
              marginBottom: 8,
              textTransform: 'uppercase',
              letterSpacing: '0.5px'
            }}>
              Vagas Limitadas para essa semana
            </span>
            <a 
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: 'inline-block',
                background: '#3ECF8E',
                color: '#FFFFFF',
                padding: '20px clamp(24px, 6vw, 48px)',
                fontSize: 20,
                fontWeight: 700,
                borderRadius: 12,
                textDecoration: 'none',
                transition: 'all 0.3s ease',
                boxShadow: '0 4px 20px rgba(62, 207, 142, 0.3)',
                fontFamily: 'Inter, system-ui, sans-serif'
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.transform = 'translateY(-2px)';
                e.currentTarget.style.boxShadow = '0 6px 30px rgba(62, 207, 142, 0.4)';
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 4px 20px rgba(62, 207, 142, 0.3)';
              }}
            >
              💥 QUERO MIGRAR PARA O SUPABASE!
            </a>
          </div>
        </div>
      </section>

      {/* A Dor e a Complexidade */}
      <section style={{
        background: '#FFFFFF',
        padding: 'clamp(60px, 12vw, 100px) 20px',
        marginTop: 2
      }}>
        <div style={{ maxWidth: 1000, margin: '0 auto' }}>
          <h2 style={{
            fontSize: 'clamp(28px, 4vw, 42px)',
            fontWeight: 800,
            color: '#1C1C1C',
            textAlign: 'center',
            marginBottom: 16,
            fontFamily: 'Inter, system-ui, sans-serif'
          }}>
            Por que não fazer sozinho?
          </h2>
          
          <p style={{
            fontSize: 18,
            color: '#3ECF8E',
            textAlign: 'center',
            marginBottom: 64,
            fontWeight: 600,
            fontFamily: 'Inter, system-ui, sans-serif'
          }}>
            A Complexidade Técnica Pode Destruir Meses de Trabalho
          </p>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
            gap: 40,
            marginBottom: 48
          }}>
            <div style={{ textAlign: 'center' }}>
              <div style={{
                width: 80,
                height: 80,
                background: 'rgba(62, 207, 142, 0.1)',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 24px',
                fontSize: 40
              }}>
                ⚠️
              </div>
              <h3 style={{
                fontSize: 22,
                fontWeight: 700,
                color: '#1C1C1C',
                marginBottom: 12,
                fontFamily: 'Inter, system-ui, sans-serif'
              }}>
                Risco de Perda Total
              </h3>
              <p style={{
                fontSize: 16,
                color: '#666',
                lineHeight: 1.6,
                fontFamily: 'Inter, system-ui, sans-serif'
              }}>
                Um erro na migração pode corromper seus dados permanentemente, apagando meses de trabalho em segundos
              </p>
            </div>

            <div style={{ textAlign: 'center' }}>
              <div style={{
                width: 80,
                height: 80,
                background: 'rgba(62, 207, 142, 0.1)',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 24px',
                fontSize: 40
              }}>
                🔗
              </div>
              <h3 style={{
                fontSize: 22,
                fontWeight: 700,
                color: '#1C1C1C',
                marginBottom: 12,
                fontFamily: 'Inter, system-ui, sans-serif'
              }}>
                Dependências Quebradas
              </h3>
              <p style={{
                fontSize: 16,
                color: '#666',
                lineHeight: 1.6,
                fontFamily: 'Inter, system-ui, sans-serif'
              }}>
                As relações entre tabelas podem ser completamente destruídas, deixando seu app inutilizável
              </p>
            </div>

            <div style={{ textAlign: 'center' }}>
              <div style={{
                width: 80,
                height: 80,
                background: 'rgba(62, 207, 142, 0.1)',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 24px',
                fontSize: 40
              }}>
                🔒
              </div>
              <h3 style={{
                fontSize: 22,
                fontWeight: 700,
                color: '#1C1C1C',
                marginBottom: 12,
                fontFamily: 'Inter, system-ui, sans-serif'
              }}>
                Preso Para Sempre
              </h3>
              <p style={{
                fontSize: 16,
                color: '#666',
                lineHeight: 1.6,
                fontFamily: 'Inter, system-ui, sans-serif'
              }}>
                Usar o "Remix" mantém você refém do Lovable Cloud, sem autonomia real sobre seu próprio projeto
              </p>
            </div>
          </div>

          <div style={{
            background: 'rgba(255, 77, 77, 0.05)',
            border: '2px solid rgba(255, 77, 77, 0.2)',
            borderRadius: 16,
            padding: 32,
            textAlign: 'center'
          }}>
            <p style={{
              fontSize: 20,
              color: '#1C1C1C',
              fontWeight: 600,
              lineHeight: 1.7,
              fontFamily: 'Inter, system-ui, sans-serif'
            }}>
              <strong style={{ color: '#FF4D4D' }}>ATENÇÃO:</strong> Tentar fazer sozinho ou usar a função de remixar vai manter você preso ou corromper seus dados, quebrar as tabelas e arruinar meses de trabalho no seu app.
            </p>
          </div>
        </div>
      </section>

      {/* Segurança Total */}
      <section style={{
        background: '#F8F9FA',
        padding: 'clamp(60px, 12vw, 100px) 20px'
      }}>
        <div style={{ maxWidth: 900, margin: '0 auto', textAlign: 'center' }}>
          <div style={{
            width: 100,
            height: 100,
            background: '#3ECF8E',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 32px',
            fontSize: 50
          }}>
            🛡️
          </div>

          <h2 style={{
            fontSize: 'clamp(32px, 4vw, 48px)',
            fontWeight: 800,
            color: '#3ECF8E',
            marginBottom: 24,
            fontFamily: 'Inter, system-ui, sans-serif'
          }}>
            Trabalho 100% Protegido por Contrato
          </h2>

          <p style={{
            fontSize: 'clamp(18px, 3vw, 22px)',
            color: '#1C1C1C',
            lineHeight: 1.7,
            marginBottom: 40,
            fontFamily: 'Inter, system-ui, sans-serif'
          }}>
            Seu projeto é precioso demais para arriscar. Por isso, todo o processo é feito de forma <strong>transparente e documentada</strong>, garantindo a proteção total dos seus dados.
          </p>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
            gap: 24,
            marginTop: 48
          }}>
            <div style={{
              background: '#FFFFFF',
              padding: 32,
              borderRadius: 12,
              boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
            }}>
              <div style={{ fontSize: 36, marginBottom: 16 }}>📄</div>
              <h4 style={{
                fontSize: 18,
                fontWeight: 700,
                color: '#1C1C1C',
                marginBottom: 8,
                fontFamily: 'Inter, system-ui, sans-serif'
              }}>
                Contrato Formal
              </h4>
              <p style={{
                fontSize: 15,
                color: '#666',
                lineHeight: 1.5,
                fontFamily: 'Inter, system-ui, sans-serif'
              }}>
                Tudo documentado e assinado
              </p>
            </div>

            <div style={{
              background: '#FFFFFF',
              padding: 32,
              borderRadius: 12,
              boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
            }}>
              <div style={{ fontSize: 36, marginBottom: 16 }}>🔐</div>
              <h4 style={{
                fontSize: 18,
                fontWeight: 700,
                color: '#1C1C1C',
                marginBottom: 8,
                fontFamily: 'Inter, system-ui, sans-serif'
              }}>
                Zero Vazamento
              </h4>
              <p style={{
                fontSize: 15,
                color: '#666',
                lineHeight: 1.5,
                fontFamily: 'Inter, system-ui, sans-serif'
              }}>
                Seus dados nunca saem do controle
              </p>
            </div>

            <div style={{
              background: '#FFFFFF',
              padding: 32,
              borderRadius: 12,
              boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
            }}>
              <div style={{ fontSize: 36, marginBottom: 16 }}>✅</div>
              <h4 style={{
                fontSize: 18,
                fontWeight: 700,
                color: '#1C1C1C',
                marginBottom: 8,
                fontFamily: 'Inter, system-ui, sans-serif'
              }}>
                Garantia Total
              </h4>
              <p style={{
                fontSize: 15,
                color: '#666',
                lineHeight: 1.5,
                fontFamily: 'Inter, system-ui, sans-serif'
              }}>
                Proteção em cada etapa do processo
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Prazos e Entregáveis */}
      <section style={{
        background: '#FFFFFF',
        padding: 'clamp(60px, 12vw, 100px) 20px'
      }}>
        <div style={{ maxWidth: 700, margin: '0 auto' }}>
          <div style={{
            background: 'linear-gradient(135deg, #3ECF8E 0%, #2AB379 100%)',
            borderRadius: 20,
            padding: 'clamp(32px, 6vw, 48px)',
            textAlign: 'center',
            color: '#FFFFFF',
            boxShadow: '0 8px 32px rgba(62, 207, 142, 0.3)'
          }}>
            <div style={{ fontSize: 56, marginBottom: 24 }}>⚡</div>
            <h2 style={{
              fontSize: 'clamp(28px, 4vw, 42px)',
              fontWeight: 800,
              marginBottom: 16,
              fontFamily: 'Inter, system-ui, sans-serif'
            }}>
              Entrega Expressa em até 48 horas*
            </h2>
            <p style={{
              fontSize: 20,
              lineHeight: 1.6,
              opacity: 0.95,
              fontFamily: 'Inter, system-ui, sans-serif'
            }}>
              Seu projeto migrando e funcionando perfeitamente no Supabase em tempo recorde
            </p>
          </div>
          
          <p style={{
            fontSize: 14,
            color: '#999',
            textAlign: 'center',
            marginTop: 16,
            fontStyle: 'italic',
            fontFamily: 'Inter, system-ui, sans-serif'
          }}>
            *O prazo exato depende da quantidade de tabelas existentes no seu banco de dados atual do Lovable Cloud.
          </p>
        </div>
      </section>

      {/* Oferta e Investimento */}
      <section style={{
        background: '#F8F9FA',
        padding: 'clamp(60px, 12vw, 100px) 20px'
      }}>
        <div style={{ maxWidth: 600, margin: '0 auto' }}>
          <h2 style={{
            fontSize: 'clamp(28px, 4vw, 42px)',
            fontWeight: 800,
            color: '#1C1C1C',
            textAlign: 'center',
            marginBottom: 48,
            fontFamily: 'Inter, system-ui, sans-serif'
          }}>
            Investimento Transparente
          </h2>

          <div style={{
            background: '#FFFFFF',
            border: '2px solid #E8E8E8',
            borderRadius: 20,
            padding: 'clamp(32px, 6vw, 48px)',
            textAlign: 'center'
          }}>
            <p style={{
              fontSize: 18,
              color: '#999',
              textDecoration: 'line-through',
              marginBottom: 8,
              fontFamily: 'Inter, system-ui, sans-serif'
            }}>
              De R$ 997,00
            </p>
            
            <div style={{ marginBottom: 24 }}>
              <span style={{
                fontSize: 'clamp(48px, 8vw, 72px)',
                fontWeight: 900,
                color: '#3ECF8E',
                fontFamily: 'Inter, system-ui, sans-serif'
              }}>
                R$ 749
              </span>
              <span style={{
                fontSize: 24,
                color: '#1C1C1C',
                fontFamily: 'Inter, system-ui, sans-serif'
              }}>
                ,00
              </span>
            </div>

            <p style={{
              fontSize: 18,
              color: '#666',
              marginBottom: 40,
              fontFamily: 'Inter, system-ui, sans-serif'
            }}>
              em até <strong>12x no cartão</strong>
            </p>

            <div style={{
              background: 'rgba(62, 207, 142, 0.05)',
              border: '2px solid rgba(62, 207, 142, 0.2)',
              borderRadius: 12,
              padding: 24,
              marginBottom: 32,
              textAlign: 'left'
            }}>
              <p style={{
                fontSize: 16,
                color: '#1C1C1C',
                marginBottom: 16,
                display: 'flex',
                alignItems: 'flex-start',
                gap: 12,
                fontFamily: 'Inter, system-ui, sans-serif'
              }}>
                <span style={{ fontSize: 20, color: '#3ECF8E', flexShrink: 0 }}>✅</span>
                <span><strong>50% de sinal</strong> para fechamento de contrato e início da migração</span>
              </p>
              <p style={{
                fontSize: 16,
                color: '#1C1C1C',
                display: 'flex',
                alignItems: 'flex-start',
                gap: 12,
                fontFamily: 'Inter, system-ui, sans-serif'
              }}>
                <span style={{ fontSize: 20, color: '#3ECF8E', flexShrink: 0 }}>✅</span>
                <span><strong>50% restantes APENAS</strong> na entrega do seu projeto rodando perfeitamente no Supabase</span>
              </p>
            </div>

            <a 
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: 'inline-block',
                background: '#3ECF8E',
                color: '#FFFFFF',
                padding: '20px clamp(24px, 6vw, 48px)',
                fontSize: 20,
                fontWeight: 700,
                borderRadius: 12,
                textDecoration: 'none',
                transition: 'all 0.3s ease',
                boxShadow: '0 4px 20px rgba(62, 207, 142, 0.3)',
                fontFamily: 'Inter, system-ui, sans-serif'
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.transform = 'translateY(-2px)';
                e.currentTarget.style.boxShadow = '0 6px 30px rgba(62, 207, 142, 0.4)';
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 4px 20px rgba(62, 207, 142, 0.3)';
              }}
            >
              💥 QUERO MIGRAR PARA O SUPABASE!
            </a>
          </div>
        </div>
      </section>

      {/* CTA Final */}
      <section style={{
        background: '#1C1C1C',
        padding: 'clamp(60px, 12vw, 100px) 20px',
        textAlign: 'center'
      }}>
        <div style={{ maxWidth: 800, margin: '0 auto' }}>
          <h2 style={{
            fontSize: 'clamp(28px, 4vw, 42px)',
            fontWeight: 800,
            color: '#FFFFFF',
            marginBottom: 24,
            lineHeight: 1.3,
            fontFamily: 'Inter, system-ui, sans-serif'
          }}>
            Não construa seu aplicativo em um terreno alugado.
          </h2>
          
          <p style={{
            fontSize: 'clamp(18px, 3vw, 24px)',
            color: '#3ECF8E',
            marginBottom: 48,
            fontWeight: 600,
            fontFamily: 'Inter, system-ui, sans-serif'
          }}>
            Faça a transição segura para o Supabase hoje mesmo.
          </p>

          <a 
            href={whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: 'inline-block',
              background: '#3ECF8E',
              color: '#FFFFFF',
              padding: '24px clamp(32px, 8vw, 56px)',
              fontSize: 22,
              fontWeight: 700,
              borderRadius: 12,
              textDecoration: 'none',
              transition: 'all 0.3s ease',
              boxShadow: '0 8px 32px rgba(62, 207, 142, 0.4)',
              fontFamily: 'Inter, system-ui, sans-serif'
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.transform = 'translateY(-2px)';
              e.currentTarget.style.boxShadow = '0 12px 40px rgba(62, 207, 142, 0.5)';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 8px 32px rgba(62, 207, 142, 0.4)';
            }}
          >
            💥 GARANTIR MINHA MIGRAÇÃO AGORA!
          </a>
        </div>
      </section>

      {/* Footer */}
      <footer style={{
        background: '#FFFFFF',
        padding: 'clamp(32px, 6vw, 48px) 20px',
        textAlign: 'center',
        borderTop: '1px solid #E8E8E8'
      }}>
        <div style={{ maxWidth: 1200, margin: '0 auto' }}>
          <Link 
            to="/produtos" 
            style={{
              color: '#666',
              textDecoration: 'none',
              fontSize: 14,
              fontFamily: 'Inter, system-ui, sans-serif'
            }}
          >
            ← Voltar para Produtos
          </Link>
          <p style={{
            color: '#999',
            fontSize: 14,
            marginTop: 24,
            fontFamily: 'Inter, system-ui, sans-serif'
          }}>
            © 2026 Extensão Lovable Ilimitado - Todos os direitos reservados
          </p>
        </div>
      </footer>
    </div>
  );
};

export default Migration;
